
import collect from 'collect.js'
import Times from '@/assets/icons/fontawesome/light/times.svg?inline'
import Search from '@/assets/icons/fontawesome/light/search.svg?inline'
import LongArrowLeft from '@/assets/icons/fontawesome/light/long-arrow-left.svg?inline'
import LongArrowRight from '@/assets/icons/fontawesome/light/long-arrow-right.svg?inline'

export default {
  components: {
    Times,
    Search,
    LongArrowLeft,
    LongArrowRight,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    destination: {
      type: Object,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
    rooms: {
      type: Array,
      required: true,
    },
  },
  computed: {
    roomsCount() {
      return collect(this.rooms).count()
    },
    adultsCount() {
      return collect(this.rooms).sum('adults')
    },
    childrenCount() {
      return collect(this.rooms).pluck('children').collapse().count()
    },
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
